import { useQuery } from "react-query";
import { client } from "shared/helpers/client";

type Lookup = "countries"| "currencies" | "languages" | "periods" | "cities" | "zones" | "banks" | "nationalities" | "payment-types" | "job-description" | "active-cities" | "service-types" | "vehicles" | "goods-type";

export function useLookups(lookups: Lookup[], zoneId?: number | string) {

  const isLoaded = (lookup: Lookup) => lookups.includes(lookup);


  const { data: countries } = useQuery(
    ["countries"],
    () =>
      client("/Owner/GetCountries").then(
        (r) => r.response
      ),
    {
      enabled: isLoaded("countries"),
    }
  );

  const { data: languages } = useQuery(
    ["languages"],
    () =>
      client("/Owner/GetLanguages").then(
        (r) => r.response
      ),
    {
      enabled: isLoaded("languages"),
    }
  );
  
  const { data: periods } = useQuery(
    ["periods"],
    () =>
      client("/Owner/GetDefaultFilterPeriods").then(
        (r) => r.response
      ),
    {
      enabled: isLoaded("periods"),
    }
  );


  const { data: currencies } = useQuery(
    ["currencies"],
    () =>
      client("/Owner/GetCurrencies").then(
        (r) => r.response
      ),
    {
      enabled: isLoaded("currencies"),
    }
  );

  const {data:activeCities} = useQuery('active-cities',
  //  () => client('cities/getAllActiveCities').then(r=> r.response), 
     {
    enabled: isLoaded("active-cities"),
  })
  const {data:jobDescriptions} = useQuery('job-description', 
  // () => client('customers/getAllPositions').then(r=> r.response),
     {
    enabled: isLoaded("job-description"),
  })

  const { data: nationalities } = useQuery(
    ["nationalities"],
    // () =>
    //   client("/nationality/getAllNationalities", { params: { companyId: company.id } }).then(
    //     (r) => r.response
    //   ),
    {
      enabled: isLoaded("nationalities"),
    }
  );

  const { data: vehicles } = useQuery(
    ["vehicles"],
    // () =>
    //   client("/vehicleType/getAllVehicleTypes", { params: { companyId: company.id } }).then(
    //     (r) => r.response
    //   ),
    {
      enabled: isLoaded("vehicles"),
    }
  );

  const { data: paymentTypes } = useQuery(
    ["payment-types"],
    // () =>
    //   client("paymentType/getAllPaymentTypes", { params: { companyId: company.id } }).then(
    //     (r) => r.response
    //   ),
    {
      enabled: isLoaded("payment-types"),
    }
  );

  const { data: banks } = useQuery(
    "banks",
    // () =>
    //   client("/bank/getAllBanks", { params: { companyId: company.id } }).then((r) => r.response),
    {
      enabled: isLoaded("banks"),
    }
  );

  const { data: serviceTypes } = useQuery(
    "serviceTypes",
    // () =>
    //   client("/serviceType/getAllServiceTypes", { params: { companyId: company.id } }).then((r) => r.response),
    {
      enabled: isLoaded("service-types"),
    }
  );

  const { data: zones } = useQuery(
    "zones",
    // () =>
    //   client("/zones/getAllZones", { params: { companyId: company.id } }).then((r) => r.response),
    {
      enabled: isLoaded("zones"),
    }
  );

  const { data: cities } = useQuery(
    ["cities", zoneId],
    // () => client("/cities/getAllCities", { params: { zoneId } }).then((r) => r.response),
    { enabled: !!zoneId }
  );


  const { data: goodTypes } = useQuery(
    ["goodTypes", ],
    // () => client("/goodType/getAllGoodTypes", { params: { companyId: company.id  } }).then((r) => r.response),
    { enabled: isLoaded("goods-type") }
  );

  return {
    countries,
    currencies,
    languages,
    periods,
    activeCities,
    banks,
    goodTypes,
    zones,
    cities,
    vehicles,
    nationalities,
    paymentTypes,
    jobDescriptions,
    serviceTypes,
  };
}
